import React, {Component} from 'react';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import InputNotification from '../../common/InputNotification';
import Header from '../Header'
import Form from '../../common/Form'
import Joi from "joi-browser";
import {Link} from 'react-router-dom'
// import ReactGA from "react-ga";
import toastr from "toastr";

class ManualFeedSource extends Form {
    constructor(props) {
        super(props);

        this.state = {
            data:
                {
                    rss: ''
                },
            feed_data: {
                id: '',
                name: '',
                website: '',
                rss: ''
            },
            spinnerActive: false,
            invalidRss: false,
            errors: {}
        };
    }

    schema = {
        rss: Joi.string().required().label("Rss field")
    };

    async componentDidMount() {
       // ReactGA.pageview(window.location.pathname + window.location.search);

        const feed_id = localStorage.getItem('feed_id');
        if (feed_id) {
            try {
                this.setState({spinnerActive: true});
                const result = await http.get('api/feed/' + feed_id, {headers: {authorization: getJwt()}});
                if (result) {
                    this.setState({
                        data: {
                            rss: result.data.data.rss
                        },
                        feedData: result.data.data
                    })
                }
                this.setState({spinnerActive: false})
            } catch (ex) {
                this.setState({spinnerActive: false});
                if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors = ex.response.data.errors;
                    this.setState({errors});
                }
                if (ex.response && ex.response.status === 401) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors.email = ex.response.data.message;
                    this.setState({errors});
                }
            }
        }
    }

    checkInputNotification = () => {
        if (this.state.spinnerActive) {
            return <InputNotification type={'loading'} text={'Checking your link'}/>
        } else if (this.state.invalidRss) {
            return <InputNotification type={'danger'} text={'We couldn\’t find a RSS feed for the URL you provided.'}/>
        }
    }

    skipForNow = async () => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Manual feed source - Skip',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        const id = localStorage.getItem("feed_id");
        try {
            const result = await http.patch('api/feed/' + id, {rss: ''}, {headers: {authorization: getJwt()}});
            // console.log(result)
            if (!result.data.rss) {
                this.props.history.push('distribution-platforms')
            }
        } catch (ex) {
            this.setState({spinnerActive: false});
            if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors = ex.response.data.errors;
                this.setState({errors});
            }
            if (ex.response && ex.response.status === 401) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors.email = ex.response.data.message;
                this.setState({errors});
            }
        }
    }

    doSubmit = async () => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Manual feed source - Verify',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        let rss = this.state.data.rss
        if (rss) {
            try {
                this.setState({spinnerActive: true});
                const checkRss = await http.post('api/check_rss', {url: rss}, {headers: {authorization: getJwt()}});
                const id = localStorage.getItem("feed_id");
                if (checkRss.data.rss_valid) {
                    try {
                        this.setState({invalidRss: false})
                        const result = await http.patch('api/feed/' + id, {rss: rss}, {headers: {authorization: getJwt()}});
                        const data = result.data;
                        if(data){
                            try{
                                const thisRssResult = await http.get('this_rss/' + id, {headers: {authorization: getJwt()}})
                            }catch{
                                toastr.error('Error Code #10057: Error with getting posts, please try adding Rss again')
                            }
                        }
                        this.setState({
                            data: {rss},
                            feed_data: data,
                            spinnerActive: false
                        });

                        if (checkRss.data.rss_valid) {
                            if (localStorage.removeSuccessMessage) {
                                localStorage.removeItem('removeSuccessMessage')
                            }
                            this.props.history.push('rss-feed-source')
                        }
                    } catch (ex) {
                        this.setState({spinnerActive: false});
                        if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                            const errors_obj = this.state.errors;
                            let errors = {...errors_obj};
                            errors = ex.response.data.errors;
                            this.setState({errors});
                        }
                        if (ex.response && ex.response.status === 401) {
                            const errors_obj = this.state.errors;
                            let errors = {...errors_obj};
                            errors.email = ex.response.data.message;
                            this.setState({errors});
                        }
                    }

                }
            } catch (ex) {
                this.setState({invalidRss: true})
                this.setState({spinnerActive: false});
                if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors = ex.response.data.errors;
                    this.setState({errors});
                }
                if (ex.response && ex.response.status === 401) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors.email = ex.response.data.message;
                    this.setState({errors});
                }
            }
        }
    };

    render() {
        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title'>Set Up Content Source</h1>
                        <p className='text-bold m-m-b'>Enter RSS link you want to source content<br/>
                            from?</p>
                        <p className='m-m-b'>RSS feed is a type of web feed which allows users and <br/>
                            applications to access updates to websites in a <br/>
                            standardized, computer-readable format.</p>
                        <form onSubmit={this.handleFormSubmit}>

                            {this.renderInput('rss', 'text', 'http://yourwebsiteurl.com')}
                            {this.checkInputNotification()}
                            {this.renderButton("Verify")}

                        </form>
                        <div className='panel-message text-center'>
                            {
                                !localStorage.navigateBackTo ?
                                    <p>Or, <Link to="#" onClick={() => this.skipForNow()}>skip for now</Link></p>
                                    :
                                    localStorage.navigateBackTo === "/content-automation" ?
                                        <p>Or, <Link to="#"
                                                     onClick={() => this.props.history.push('/feed-source')}>back</Link>
                                        </p>
                                        :
                                        <p>Or, <Link to="#"
                                                     onClick={() => this.props.history.push('/rss-feed-source')}>back</Link>
                                        </p>
                            }
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default ManualFeedSource;